export const cleanUrlQuery = (query) => {
    const resultQuery = {};
    Object.keys(query).forEach((key) => {
        if (query[key] != null) {
            resultQuery[key] = query[key];
        }
    });
    return resultQuery;
};
export const formatUrl = (urlObject) => {
    const { protocol, host, pathname, query } = urlObject;
    let cleanedQueryString;
    if (query && typeof query === 'object') {
        // NOTE remove undefined or null values from query
        const cleanedQuery = cleanUrlQuery(query);
        cleanedQueryString = new URLSearchParams(cleanedQuery).toString();
    }
    else {
        cleanedQueryString = query;
    }
    return ((protocol ? `${protocol}//` : '') +
        (host ?? '') +
        pathname +
        (cleanedQueryString ? `?${cleanedQueryString}` : ''));
};
export const getUrlParams = (url) => {
    const searchParams = {};
    const { searchParams: iterableSearchParams } = new URL(url);
    iterableSearchParams.forEach((value, key) => {
        searchParams[key] = value;
    });
    return searchParams;
};
export const getUrlHashParams = (url) => {
    const hashParams = {};
    const { hash } = new URL(url);
    const iterableHashParams = new URLSearchParams(hash.substring(1));
    iterableHashParams.forEach((value, key) => {
        hashParams[key] = value;
    });
    return hashParams;
};
export const addUrlParams = (url, searchParams, hashParams) => {
    if (!Object.keys(searchParams).length &&
        (!hashParams || !Object.keys(hashParams).length))
        return url;
    const { protocol, host, pathname } = new URL(url);
    const initialSearchParams = getUrlParams(url);
    const mergedSearchParams = cleanUrlQuery({
        ...initialSearchParams,
        ...searchParams
    });
    const search = new URLSearchParams(mergedSearchParams).toString();
    const urlSearch = search ? `?${search}` : '';
    const initialHashParams = getUrlHashParams(url);
    const mergedHashParams = cleanUrlQuery({
        ...initialHashParams,
        ...hashParams
    });
    const hash = new URLSearchParams(mergedHashParams).toString();
    const urlHash = hash ? `#${hash}` : '';
    return `${protocol}//${host}${pathname}${urlSearch}${urlHash}`;
};
export const removeUrlHash = (url) => {
    const { protocol, host, pathname, search } = new URL(url);
    return `${protocol}//${host}${pathname}${search}`;
};
export const collectIdStats = (href) => {
    const { src, type, param, extra, rname = 'id' } = getUrlParams(href);
    const formType = src || type || param || (rname !== 'id' && 'redirect') || 'self';
    return {
        project: rname,
        type: formType,
        ...(extra && {
            extra
        })
    };
};
export const collectUtmParams = (href) => {
    const urlParams = getUrlParams(href);
    const { referer = document.referrer } = urlParams;
    return Object.keys(urlParams).reduce((p, param) => ({
        ...p,
        ...(/^utm_(source|campaign|medium|content|term)$/.test(param) && {
            [param]: urlParams[param]
        })
    }), referer ? { referer } : {});
};
export const getProviderOrigin = (href) => {
    return getUrlParams(href).iframeOrigin || document.referrer;
};
export const openedInIframe = (href) => {
    return getUrlParams(href).param === 'iframe' || window.parent !== window;
};
export const isOriginInvalid = (href) => {
    const { host } = new URL(href);
    return host !== 'id.rambler.ru';
};
export const checkRedirectDomain = (href = '', allowedDomains = []) => {
    if (/^chrome-extension:\/\//.test(href)) {
        return true;
    }
    if (!allowedDomains || allowedDomains.length === 0) {
        return false;
    }
    const { hostname } = new URL(href, window.location.origin);
    const hostnameDomains = hostname.split('.');
    const firstLevelDomain = hostnameDomains.slice(-1).join('.');
    const secondLevelDomain = hostnameDomains.slice(-2).join('.');
    return allowedDomains.some((allowedDomain) => allowedDomain === firstLevelDomain || allowedDomain === secondLevelDomain);
};
export const getEmailOrderExtra = (base, href) => {
    const extra = {
        ...base,
        via: collectIdStats(href),
        utm: collectUtmParams(href)
    };
    return encodeURIComponent(JSON.stringify(extra));
};
export const getRedirectDeepLink = (schema = '', defaultLink = '', allowedSchemas = []) => {
    if (!allowedSchemas) {
        return;
    }
    let deepLink = ~allowedSchemas.indexOf(`ramblerid${schema}`)
        ? `ramblerid${schema}`
        : ~allowedSchemas.indexOf(schema)
            ? schema
            : null;
    if (deepLink && !~deepLink.indexOf('://')) {
        deepLink += `://${defaultLink}`;
    }
    return deepLink;
};
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURIComponent
export const encodeURIComponentRFC3986 = (value) => encodeURIComponent(value).replace(/[!'()*]/g, (c) => `%${c.charCodeAt(0).toString(16)}`);
